/* Shared JS Imports */
import '@popperjs/core';
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import 'bootstrap-table/dist/bootstrap-table.js'

import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
window.Chart = Chart;
window.ChartDataLabels = ChartDataLabels;
